import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
	selector: 'ScannerPopUp',
	templateUrl: 'ScannerPopUp.html',
	
})

export class ScannerPopUpComponent implements OnInit {
	ngOnInit(): void {
	}

	@Output() scanResult = new EventEmitter<string>();

	scanSuccess(result: string) {
		var thisHolder = this;
		if (result) {
			thisHolder.scanResult.emit(result);
		}
	}
	camerasNotFound(devices: MediaDeviceInfo[]) {
		this.qrResult = 'No Cameras Found';
	}
	camerasFound(cams: MediaDeviceInfo[]) {
		this.availableDevices = cams;
		console.log("Devices", cams);
		if (cams && cams.length > 0) {
			this.selectedDevice = cams[0];
			this.camStarted = true;
		}
	}

	@ViewChild('scanner')
	scanner: ZXingScannerComponent;

	constructor() {
	}

	scannerSetUp: boolean = false;
	_visible: boolean = false;
	@Input()
	get visible(): boolean {
		return this._visible;
	}
	set visible(val: boolean) {
		this._visible = val;
		if (val) {

		}
	}

	camStarted = false;
	selectedDevice: any = null;
	searchText: string = "Searching...";
	qrResult = this.searchText;
	availableDevices: any[] = [];
	allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_93, BarcodeFormat.CODE_39, BarcodeFormat.CODE_128, BarcodeFormat.UPC_A ];
	

	

	onChange(selectedValue: string) {
		this.camStarted = false;
		this.selectedDevice = selectedValue;
		if (selectedValue) {
			this.camStarted = true;
		}
	}
	
}
